import React from 'react';

export const MarLocNameModal = {
  title: 'Marigram Location',
  body: (
    <div>
      <p>Location of tide gauge observation.</p>
    </div>
  ),
};
